import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Init self adhesion process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesioninit
*/
export const initSelfAdhesionProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/init',
		params: payload
	})
}

/** Resend OTP for self adhesion process init
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionresendotp
*/
export const resentOTP = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/resend/otp',
		params: payload
	})
}

/** Validate OTP for self adhesion process init
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionvalidateotp
*/
export const validateOTP = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/validate/otp',
		data: payload
	})
}

/** Validate form info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionvalidateform
*/
export const validateForm = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/validate/form',
		data: payload
	})
}

/** Submit adhesion info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionsubmit
*/
export const submitAdhesionInfo = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/submit',
		data: payload
	})
}

/** Consult adhesion process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionfinish
*/
export const consultAdhesionProcess = payload => {
	return httpClient({
		method: 'GET',
		url: `self/adhesion/${payload}`
	})
}

/** Finish adhesion process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionfinish
*/
export const finishAdhesionProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/finish',
		data: payload
	})
}

/** Resend code and generate new debit entry for finsh process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_selfadhesionresendtoken
*/
export const resendFinishAdhesionProcessToken = payload => {
	return httpClient({
		method: 'POST',
		url: 'self/adhesion/resend/token',
		data: payload
	})
}

/** Consult adhesion process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_retrieveCredentials%7BprocessId%7D
*/
export const consultRecoverCredentialsProcess = payload => {
	return httpClient({
		method: 'GET',
		url: `/retrieveCredentials/${payload}`
	})
}
